module.exports = __webpack_public_path__ + "img/plan_de_estudio.e74aab8f.png";